import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import { Grid } from "@mui/material";
import AddFaq from "../../../components/FaqComponent/AddFaq";
import AddFaqModel from "components/FaqComponent/FaqCategoriesModel/AddFaqModel";
import Breadcrumbs from "components/common/Breadcrumbs";
import Link from "components/common/Link";
import Text from "components/common/Text";

class FaqAddContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      id: null,
      is_update: false,
    };
    // Binding the methods
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClickOpenModel = this.handleClickOpenModel.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.onChangeCategory = this.onChangeCategory.bind(this);
    this.handleChangeF = this.handleChangeF.bind(this);
  }

  componentDidMount() {
    const { getCategoriesList, getFaqParentCategories, getFaqTableAction,id } = this.props;
  
    getCategoriesList();
    getFaqParentCategories({ parent_id: 0 });
    if (id) {
      this.setState({ id: id, is_update: true });
      getFaqTableAction({ id });
    }
  }

  async handleSubmit(payload) {
  
    try {
      const res = await this.props.postFaqAction(payload);
      if (res) this.setState({ open: true });
    } catch(err) {
      console.error(err);
    }
  }

  handleClickOpenModel() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
    this.props.history.push("/faqs");
  }

  async handleUpdate(payload) {
  const { id } = this.state;
  const payload1 = {
    id,
    ...payload
  };
  try {
    const res = await this.props.updateFaq(payload1);
    if (res) {
      this.setState({ open: true });
      this.props.onEditSuccess();
    }
  } catch(err) {
    console.error(err);
  }
}

  async onChangeCategory(val) {
    try {
      await this.props.getCategoriesList({ parent_id: val});
      
    } catch(err) {
      console.error(err);
    }
  }


  async handleChangeF(val) {
    try {
      await this.props.getFaqParentCategories({ parent_id: 0,content_type:val});
    } catch(err) {
      console.error(err);
    }
}


  render() {
    const { open, is_update } = this.state;
    const { ParentCategoriesList, CategoriesList, FaqTableList,handleBack } = this.props;

    return (
      <>
        <Stack p={0.5} mt={2}>
          <Breadcrumbs
            sx={{ fontSize: "14px", color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Link
              sx={{ fontSize: "14px" }}
              underline="hover"
              color="#A2A7AE"
              href="/faqs"
            >
              FAQ
            </Link>
            <Text sx={{ fontSize: "14px" }} color="#0DA861">
              {is_update ? "Edit" : "Add"} FAQs
            </Text>
          </Breadcrumbs>
        </Stack>
        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Stack spacing={3}>
              <AddFaq
                data={FaqTableList}
                category={CategoriesList}
                handleBack={()=>window.history.back()}
                submit={this.handleSubmit}
                update={this.handleUpdate}
                is_update={is_update}
                ParentCategoriesList={ParentCategoriesList}
                onChangeCategory={this.onChangeCategory}
                handleChangeF={this.handleChangeF}
              />
              <AddFaqModel
                open={open}
                handleClose={this.handleClose}
                is_update={is_update}
              />
            </Stack>
          </Paper>
        </Grid>
      </>
    );
  }
}

export default FaqAddContainer;
